// ArchiveEsimModal.js
import React, { useState } from "react";
import { X, AlertTriangle } from "lucide-react";
import "./ArchiveEsimModal.css";
import { useLanguage } from "../../i18n/LanguageContext";

export default function ArchiveEsimModal({
                                             open,
                                             onClose,
                                             simId,
                                             onArchived, // optional callback to let parent update state / navigate
                                         }) {
    const [saving, setSaving] = useState(false);
    const { t } = useLanguage();

    if (!open) return null;

    const handleConfirm = async () => {
        try {
            setSaving(true);

            const resp = await fetch("https://api.artamobile.id/v1/esims/archive", {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ SimId: simId }),
            });

            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

            onArchived?.();
            onClose();
            alert(t("archiveModal.success"));
        } catch (err) {
            console.error(err);
            alert(t("archiveModal.failed"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="archive-modal-backdrop" role="dialog" aria-modal="true">
            <div className="archive-modal">
                <button
                    className="archive-modal-close"
                    aria-label={t("common.close")}
                    onClick={onClose}
                >
                    <X size={20} />
                </button>

                <div className="archive-modal-header">
                    <AlertTriangle size={24} className="archive-modal-icon" />
                    <h3 className="archive-modal-title">{t("archiveModal.title")}</h3>
                </div>

                <p className="archive-modal-text">
                    {t("archiveModal.body")}
                    <br />
                    {t("archiveModal.confirmQuestion")}
                </p>

                <div className="archive-modal-actions">
                    <button
                        className="archive-btn-secondary"
                        type="button"
                        onClick={onClose}
                        disabled={saving}
                    >
                        {t("archiveModal.cancel")}
                    </button>
                    <button
                        className="archive-btn-primary"
                        type="button"
                        onClick={handleConfirm}
                        disabled={saving}
                    >
                        {saving ? t("archiveModal.archiving") : t("archiveModal.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
}
